/** @jsxImportSource @emotion/react */

import EmptyImg from "assets/desktop/images/emptyData.png";
import Loading from "components/common/Loading";
import GameFavouriteCard from "components/desktop/GameFavouriteCard";
import _map from "lodash/map";
import { useSelector } from "react-redux";
import {
  selectDataSubGameFavourite,
  selectIsSubGamesFavouriteLoading,
} from "store/game";

import { FavouriteGamePageStyle } from "./index.style";
const FavouriteGamePage = () => {
  const listFavourite = useSelector(selectDataSubGameFavourite);
  const isLoading = useSelector(selectIsSubGamesFavouriteLoading);

  const renderList = () => {
    if (!listFavourite?.length) {
      return (
        <div css={FavouriteGamePageStyle.bodyEmpty}>
          <img alt="" src={EmptyImg} />
          <h3>Không có dữ liệu nào được lưu </h3>
          <span>Mau chóng đi đăng ký trò chơi yêu thích của bạn nào !</span>
        </div>
      );
    }

    return (
      <div css={FavouriteGamePageStyle.body}>
        {_map(listFavourite, (item, index) => (
          <GameFavouriteCard key={index} {...item} />
        ))}
      </div>
    );
  };
  return (
    <div css={FavouriteGamePageStyle.self}>
      <div css={FavouriteGamePageStyle.head}>
        {/* <BackwardStepIcon css={FavouriteGamePageStyle.backIcon} /> */}
        <h4 css={FavouriteGamePageStyle.title}>Yêu thích nhất</h4>
      </div>
      {isLoading ? <Loading height={400} center /> : renderList()}
    </div>
  );
};

export default FavouriteGamePage;
